import React from 'react'
import { createRoot } from 'react-dom/client'
import { injectFonts } from './brand'
import SingleCruise from './apps/SingleCruise/index.jsx'
import SingleItinerary from './apps/SingleItinerary/index.jsx'
import CategoryPage from './apps/CategoryPage/index.jsx'
import HomePage from './apps/HomePage/index.jsx'
import SinglePost from './apps/SinglePost/index.jsx'
import ContactPage from './apps/ContactPage/index.jsx'
import NotFound from './apps/NotFound/index.jsx'
import Footer from './apps/components/Footer.jsx'
import Header from './apps/components/Header.jsx'
import './index.css'

injectFonts()

const appMap = {
  'single-cruise':    SingleCruise,
  'single-itinerary': SingleItinerary,
  'category':         CategoryPage,
  'home':             HomePage,
  'single-post':      SinglePost,
  'contact':          ContactPage,
  'not-found':        NotFound,
}

const root = document.getElementById('app-root')
if (root) {
  const appKey = root.dataset.app
  const App = appMap[appKey]
  if (App) {
    createRoot(root).render(<App data={window.wpData} />)
  }
}

const headerRoot = document.getElementById('header-root')
if (headerRoot) {
  createRoot(headerRoot).render(<Header />)
}

const footerRoot = document.getElementById('footer-root')
if (footerRoot) {
  createRoot(footerRoot).render(<Footer contact={window.wpData?.contact ?? {}} />)
}
